import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { setContext } from "apollo-link-context";
import { onError } from "apollo-link-error";
export var authEvent = new Event("auth");
export function getAuthToken() {
  try {
    return localStorage.getItem("token");
  } catch (_unused) {
    return null;
  }
}
export function setAuthToken(token) {
  localStorage.setItem("token", token);
  dispatchEvent(authEvent);
}
export function removeAuthToken() {
  localStorage.removeItem("token");
  dispatchEvent(authEvent);
}
export function clearStorage() {
  localStorage.clear();
  dispatchEvent(authEvent);
}
export function fireSignOut(client) {
  clearStorage();

  if (navigator.credentials && navigator.credentials.preventSilentAccess) {
    navigator.credentials.preventSilentAccess();
  }

  if (client) {
    client.resetStore();
  }
}
// possibly remove callback here and use event emitter
export var invalidTokenLinkWithTokenHandler = function invalidTokenLinkWithTokenHandler(tokenExpirationCallback) {
  var link = onError(function (error) {
    var _error$graphQLErrors;

    var isTokenExpired = (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : _error$graphQLErrors.some(function (error) {
      var _error$extensions, _error$extensions$exc;

      return ((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : (_error$extensions$exc = _error$extensions.exception) === null || _error$extensions$exc === void 0 ? void 0 : _error$extensions$exc.code) === "JSONWebTokenExpired";
    });

    if (isTokenExpired || error.networkError && error.networkError.statusCode === 401) {
      tokenExpirationCallback();
    }
  });
  return {
    link: link
  };
};
export var authLink = setContext(function (_, context) {
  var authToken = getAuthToken();

  if (authToken) {
    return _objectSpread({}, context, {
      headers: _objectSpread({}, context.headers, {
        Authorization: authToken ? "JWT ".concat(authToken) : null
      })
    });
  } else {
    return context;
  }
});